const getCategoryKeyById = (
  categoryId: number | string,
  variant: 'long' | 'short' = 'long',
): string => (variant === 'short' ? `category-${categoryId}-short` : `category-${categoryId}`);

export default getCategoryKeyById;
